"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchers = void 0;
var reportsActions = require("@caddigital/sok-reducers/lib/actions/reports");
var ToastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var mapDispatchers = function (dispatch) {
    return {
        retrieveReport: function (uuid, type) {
            return dispatch(reportsActions.retrieveReportRequest(uuid, type));
        },
        closeModal: function () {
            dispatch(reportsActions.fieldsModalClose());
            dispatch(reportsActions.clearRetrievedReport());
        },
        fetchReportFields: function (customerId) {
            return dispatch(reportsActions.fetchReportFieldsRequest({ customerId: customerId }));
        },
        clearReportFields: function () { return dispatch(reportsActions.clearReportFields()); },
        showFetchingFieldsErrorToast: function () {
            var title = (0, translation_1.getLocalization)('management/reports/modal/fields/errorToast/fetchFields/error/title');
            var message = (0, translation_1.getLocalization)('management/reports/modal/fields/errorToast/fetchFields/error/message');
            dispatch(ToastActions.addNewToast(title, message, 'FAILURE'));
        },
        showReportCreationSuccessToast: function () {
            var title = (0, translation_1.getLocalization)('management/reports/modal/fields/successToast/createReport/success/title');
            var message = (0, translation_1.getLocalization)('management/reports/modal/fields/successToast/createReport/success/message');
            dispatch(ToastActions.addNewToast(title, message, 'NORMAL'));
        },
        showReportCreationErrorToast: function () {
            var title = (0, translation_1.getLocalization)('management/reports/modal/fields/errorToast/createReport/error/title');
            var message = (0, translation_1.getLocalization)('management/reports/modal/fields/errorToast/createReport/error/message');
            dispatch(ToastActions.addNewToast(title, message, 'FAILURE'));
        },
        showUpdateReportFailureToast: function () {
            var title = (0, translation_1.getLocalization)('management/reports/modal/fields/errorToast/updateReport/error/title');
            var message = (0, translation_1.getLocalization)('management/reports/modal/fields/errorToast/updateReport/error/message');
            dispatch(ToastActions.addNewToast(title, message, 'FAILURE'));
        },
        showTemplateCreationSuccessToast: function () {
            var title = (0, translation_1.getLocalization)('management/reports/modal/fields/successToast/createTemplate/success/title');
            var message = (0, translation_1.getLocalization)('management/reports/modal/fields/successToast/createTemplate/success/message');
            dispatch(ToastActions.addNewToast(title, message, 'NORMAL'));
        },
        showTemplateCreationErrorToast: function () {
            var title = (0, translation_1.getLocalization)('management/reports/modal/fields/errorToast/createTemplate/error/title');
            var message = (0, translation_1.getLocalization)('management/reports/modal/fields/errorToast/createTemplate/error/message');
            dispatch(ToastActions.addNewToast(title, message, 'FAILURE'));
        },
        showUpdateReportSuccessToast: function () {
            var title = (0, translation_1.getLocalization)('management/reports/modal/fields/successToast/updateReport/success/title');
            var message = (0, translation_1.getLocalization)('management/reports/modal/fields/successToast/updateReport/success/message');
            dispatch(ToastActions.addNewToast(title, message, 'NORMAL'));
        },
        clearCreateReportStatus: function () { return dispatch(reportsActions.clearCreateReport()); },
        createReport: function (createReport) {
            return dispatch(reportsActions.createReportRequest(createReport));
        },
        updateReport: function (customerId, reportUuid, payload) {
            return dispatch(reportsActions.updateReportTemplateRequest(customerId, reportUuid, payload));
        }
    };
};
exports.mapDispatchers = mapDispatchers;
